import React from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './CustomerExpectationsCheck.styles';

type CustomerExpectationsCheckProps = {
  isChecked: boolean;
  setIsChecked: (isChecked: boolean) => void;
  setIsCustomerExpectationModalOpen: (isOpen: boolean) => void;
};

const CustomerExpectationsCheck = ({
  isChecked,
  setIsChecked,
  setIsCustomerExpectationModalOpen,
}: CustomerExpectationsCheckProps) => {
  const { t } = useTranslation();

  const handleOpenModal = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    setIsCustomerExpectationModalOpen(true);
  };

  return (
    <St.Container>
      <St.Input
        type="checkbox"
        value="customer-expectations"
        isChecked={isChecked}
        label={
          <>
            {t('ORDER_SUMMARY.ESTIMATE_SECTION.AGREEMENT_TEXT')}
            <St.Link onClick={handleOpenModal}>
              {t('ORDER_SUMMARY.ESTIMATE_SECTION.AGREEMENT_TEXT_CLICKABLE')}
            </St.Link>
          </>
        }
        onChange={() => setIsChecked(!isChecked)}
      />
    </St.Container>
  );
};

export default CustomerExpectationsCheck;
